<template>
  <div id="home-featured-header" class="featured-header">
    <div class="featured-header__title">
      {{ title }}
    </div>
    <router-link v-if="route"
                 class="button-default"
                 :to="route"
    >
      view all
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'HomeFeaturedHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    route: {
      type: Object,
      required: false,
      default: () => {}
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
.featured-header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 50px;
  &__title {
    @include font-18-md;
    text-transform: uppercase;
  }
}
</style>
